import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import {
  Text,
  Image,
  TouchableOpacity,
  View,
  TouchableHighlight,
} from "react-native";
import { AppScreens } from "../../../Utility/AppScreens";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { useEffect, useState } from "react";
import { CommonButton } from "../../../../common/CommonButton";
import SignUpModal from "../Modals/SignUpModal";

import { CommonTag } from "../../../../common/CommonTag";
import { CommonProgressbar } from "../../../../common/CommonProgressbar";
import PlayersViewComponent from "../../../../Components/home-common-components/PlayersViewComponent";
import ShareComponent from "../../../../Components/ShareComponent";
import React from "react";
import CardTags from "../../../../Components/home-common-components/CardTags";
import BuyTicketModal from "../Modals/BuyTicketModal";
import Separator from "../../../../Components/Separator";
import ImageComponent from "../../../../Components/ImageComponent";
import { AppImages } from "../../../../utility/AppImages";
import Tooltip from "react-native-walkthrough-tooltip";
import { useTooltips } from "../../../../context/WalkthroughContext";

export default function HomeItem(props) {
  const {
    index,
    item,
    heading,
    accessToken,
    screenName,
    eventID = "",
    userData,
    userProfileData,
    firstGetTicketIndex,
    firstSignUpIndex,
    // getTicketTapped,
    loadEventDetailScreen,
  } = props;
  const navigation = useNavigation();
  const [isGetTicket, setIsGetTicket] = useState(false);

  useEffect(() => {
    if (item.eventID === eventID) {
      setIsGetTicket(true);
    } else {
      setIsGetTicket(false);
    }
  }, [item.eventID, eventID]);

  const [isSignUp, setIsSignUp] = useState(false);
  const [attendeeIDs, setAttendeeIDs] = useState(item.attendeeIDs || []);
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const flag = item.type === "Private" ? 0 : 1;

  const percentage =
    attendeeIDs && item.minimumAttendees
      ? Math.round((attendeeIDs.length * 100) / item.minimumAttendees)
      : 0;

  const isUserAttendee = attendeeIDs.includes(userData.username);
  const isPlayer = item.participantIDs.includes(userData.username);
  const {
    signupEventTooltipVisible,
    ticketEventTooltipVisible,
    setSignupEventTooltipVisible,
    setTicketEventTooltipVisible,
    resetTooltips,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();

  return (
    <View style={[styles.cardContainer]}>
      <TouchableOpacity
        style={[styles.listBgViewStyle]}
        onPress={() => {
          if (heading === "Past Events") {
            navigateToScreen(navigation, AppScreens.PastEvent, {
                eventID: item.eventID,
              });
          } else if (item.status === "ongoing") {
            navigateToScreen(navigation, AppScreens.LiveStreaming, {
                eventId: item.eventID,
              });
          } else if (item.status === "Upcoming") {
            navigateToScreen(navigation, AppScreens.GameShowScreen, {
                eventID: item.eventID,
              });
          } else if (item.status === "complete") {
            navigateToScreen(navigation, AppScreens.PastEvent, {
                eventID: item.eventID,
              });
          }
        }}
      >
        <View
          style={{
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_12,
              {
                color: AppColors.white,
                marginTop: 10,
                width: 150,
              },
            ]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {item.title}
          </Text>
        </View>
        <View style={styles.detailCard}>
          {heading === "Past Events" ? null : flag === 0 ? (
            <CommonTag
              numberOfLines={1}
              title={`Min ${
                deviceSize !== DEVICE_SIZES.SM && deviceSize !== DEVICE_SIZES.XS
                  ? "required"
                  : ""
              } Attendees: ${
                item.minimumAttendees ? item.minimumAttendees : 0
              }`}
              tagStyle={[
                styles.attendeesBgViewStyle,
                {
                  backgroundColor: AppColors.red_AF0707,
                },
              ]}
            />
          ) : (
            <CommonTag
              numberOfLines={1}
              title={
                item.status === "complete"
                  ? "Event is Completed"
                  : item.status === "ongoing"
                  ? "Battle is On"
                  : item.status === "Upcoming"
                  ? "Event will begin soon"
                  : "Unknown Status"
              }
              tagStyle={{
                backgroundColor:
                  item.status === "complete"
                    ? AppColors.grayColor_484848
                    : item.status === "ongoing"
                    ? AppColors.appGreenColor_51AF07
                    : item.status === "Upcoming"
                    ? AppColors.appViolentColor_6D08C3
                    : AppColors.appGreenColor_51AF07,
                borderRadius: 7,
                alignSelf: "flex-start",
              }}
            />
          )}
          <PlayersViewComponent
            styles={styles}
            participants={item.participantDetails}
          />

          <CommonTag
            title={`${attendeeIDs ? attendeeIDs.length : 0} Attendees`}
            tagStyle={styles.attendeesBgViewStyle}
          />
        </View>
      </TouchableOpacity>
      {/* User detail view */}
      <View
        style={{
          backgroundColor: AppColors.appGrayColor_1C1C1C,
          height: 10,
          borderRadius: 8,
          marginTop: 10,
        }}
      >
        <CommonProgressbar percentage={percentage} />
      </View>
      <CardTags item={item} />
      {screenName == "Home" && (
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <View>
            <ShareComponent
              accessToken={accessToken}
              item={item}
              eventID={item.eventID}
            />
          </View>
          {heading === "Past Events" ? (
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_12,
                {
                  color: AppColors.white,
                  marginTop: 10,
                  width: 150,
                  textAlign: "right",
                },
              ]}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              Event Completed
            </Text>
          ) : !isPlayer ? (
            !isUserAttendee ? (
              flag === 0 ? (
                <View style={{ alignSelf: "flex-start" }}>
                  {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                    <Tooltip
                      isVisible={
                        firstGetTicketIndex === index &&
                        ticketEventTooltipVisible &&
                        heading === "Popular Events"
                      }
                      contentStyle={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        width: 600,
                      }}
                      displayInsets={{ top: 0, bottom: 0, left: 0, right: 50 }}
                      arrowStyle={{
                        display: "none",
                      }}
                      content={
                        <View
                          style={{
                            backgroundColor: AppColors.appBlueColor_3A5175,
                            padding: 10,
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <View style={{ gap: 10 }}>
                            <ImageComponent
                              url={AppImages.walkthroughImage}
                              style={{
                                height: 130,
                                width: 130,
                              }}
                            />
                            <View style={{ width: 130 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Pro Tip:
                                </Text>
                                Ticketed events bring exclusive content and
                                allow you to engage in the ultimate spectator
                                experience!
                              </Text>
                            </View>
                          </View>
                          <View style={{ flex: 1, gap: 30 }}>
                            <View style={{ gap: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.BOLD_ANYBODY_12,
                                  { color: AppColors.white },
                                ]}
                              >
                                Get Tickets for Exclusive Events 🎟️
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                Esquadifi’s exclusive, ticketed events provide
                                premium access that only ticket holders can
                                enjoy:
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Find Ticketed Events:
                                </Text>
                                Look for Exclusive Events in the Events list for
                                access to high-stakes, limited-access streams.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Purchase a Ticket:
                                </Text>
                                Get your ticket for entry to these special
                                events. Ticket holders can participate in the
                                live chat and send gifts, just like in Kall-Out
                                Events.
                              </Text>
                            </View>
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 10,
                              }}
                            >
                              {/* Dots (Step Indicator) */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 5,
                                  justifyContent: "center",
                                  marginBottom: 10,
                                }}
                              >
                                {Array.from({ length: totalSteps }).map(
                                  (_, index) => (
                                    <View
                                      key={index}
                                      style={{
                                        height: 6,
                                        width: 6,
                                        borderRadius: 5,
                                        backgroundColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                        borderWidth: 1,
                                        borderColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                      }}
                                    />
                                  )
                                )}
                              </View>
                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                }}
                              >
                                Click “Finish” to stop tutorial.
                              </Text>
                              <TouchableOpacity
                                onPress={() => {
                                  resetTooltips();
                                }}
                                style={{
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  width: 70,
                                  height: 20,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 10,
                                }}
                              >
                                <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                  Finish
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </View>
                        </View>
                      }
                      placement="top"
                    >
                      <TouchableHighlight>
                        <CommonButton
                          title="Get Ticket"
                          onTap={() => {
                            setIsGetTicket(true);
                          }}
                          buttonStyle={styles.btnStyle}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                        />
                      </TouchableHighlight>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      isVisible={
                        firstGetTicketIndex === index &&
                        ticketEventTooltipVisible &&
                        heading === "Popular Events"
                      }
                      contentStyle={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        width: 350,
                      }}
                      displayInsets={{ top: 0, bottom: 0, left: 10, right: 10 }}
                      arrowStyle={{
                        display: "none",
                      }}
                      content={
                        <View
                          style={{
                            backgroundColor: AppColors.appBlueColor_3A5175,
                            padding: 10,
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <View style={{ flex: 1, gap: 10 }}>
                            <View style={{ gap: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.BOLD_ANYBODY_12,
                                  { color: AppColors.white }, // Set text color for better readability
                                ]}
                              >
                                Get Tickets for Exclusive Events 🎟️
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                Esquadifi’s exclusive, ticketed events provide
                                premium access that only ticket holders can
                                enjoy:
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Find Ticketed Events:
                                </Text>
                                Look for Exclusive Events in the Events list for
                                access to high-stakes, limited-access streams.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Purchase a Ticket:
                                </Text>
                                Get your ticket for entry to these special
                                events. Ticket holders can participate in the
                                live chat and send gifts, just like in Kall-Out
                                Events.
                              </Text>
                            </View>
                            <View style={{ marginTop: 10 }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Dots (Step Indicator) */}
                                <View
                                  style={{
                                    flexDirection: "row",
                                    gap: 5,
                                    alignItems: "center",
                                  }}
                                >
                                  {Array.from({ length: totalSteps }).map(
                                    (_, index) => (
                                      <View
                                        key={index}
                                        style={{
                                          height: 6,
                                          width: 6,
                                          borderRadius: 5,
                                          backgroundColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                          borderWidth: 1,
                                          borderColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                        }}
                                      />
                                    )
                                  )}
                                </View>

                                <TouchableOpacity
                                  onPress={() => {
                                    resetTooltips();
                                  }}
                                  style={{
                                    backgroundColor:
                                      AppColors.appViolentColor_6D08C3,
                                    width: 70,
                                    height: 20,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 10,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                    Finish
                                  </Text>
                                </TouchableOpacity>
                              </View>
                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                  marginTop: 15,
                                }}
                              >
                                Click “Finish” to stop tutorial.
                              </Text>
                            </View>
                          </View>
                        </View>
                      }
                      placement="top"
                      // childContentSpacing={20}
                      // onClose={() => setToolTipVisible(false)}
                    >
                      <TouchableHighlight>
                        <CommonButton
                          title="Get Ticket"
                          onTap={() => {
                            setIsGetTicket(true);
                            // getTicketTapped();
                          }}
                          buttonStyle={styles.btnStyle}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                        />
                      </TouchableHighlight>
                    </Tooltip>
                  )}
                </View>
              ) : (
                <View style={{ alignSelf: "flex-start" }}>
                  {deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? (
                    <Tooltip
                      isVisible={
                        firstSignUpIndex === index &&
                        signupEventTooltipVisible &&
                        heading === "Popular Events"
                      }
                      contentStyle={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        width: 600,
                      }}
                      displayInsets={{ top: 0, bottom: 0, left: 0, right: 50 }}
                      arrowStyle={{
                        display: "none",
                      }}
                      content={
                        <View
                          style={{
                            backgroundColor: AppColors.appBlueColor_3A5175,
                            padding: 10,
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <View style={{ gap: 10 }}>
                            <ImageComponent
                              url={AppImages.walkthroughImage}
                              style={{
                                height: 130,
                                width: 130,
                              }}
                            />
                            <View style={{ width: 130 }}>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Pro Tip:
                                </Text>
                                Check out subscription options to unlock perks,
                                reduced fees, and priority profile placement!
                              </Text>
                            </View>
                          </View>
                          <View style={{ flex: 1, gap: 30 }}>
                            <View style={{ gap: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.BOLD_ANYBODY_12,
                                  { color: AppColors.white },
                                ]}
                              >
                                Sign Up to Watch Free Events ✍️
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                Ready to join the Esquadifi community? Signing
                                up lets you access all free Kall-Out Events and
                                enjoy exciting matches live.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Join Free Events:
                                </Text>
                                Once signed up, you can register for any
                                Kall-Out Event to watch live, cheer for players,
                                and engage in chat.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Build Your Profile:
                                </Text>
                                Create your profile to track stats, interact
                                with other fans, and be part of the community.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Unlock Special Abilities:
                                </Text>
                                Sign up to start collecting coins, belts, and
                                real rewards as you progress in Esquadifi!
                              </Text>
                            </View>
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 10,
                              }}
                            >
                              {/* Dots (Step Indicator) */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 5,
                                  justifyContent: "center",
                                  marginBottom: 10,
                                }}
                              >
                                {Array.from({ length: totalSteps }).map(
                                  (_, index) => (
                                    <View
                                      key={index}
                                      style={{
                                        height: 6,
                                        width: 6,
                                        borderRadius: 5,
                                        backgroundColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                        borderWidth: 1,
                                        borderColor:
                                          currentStep === index
                                            ? AppColors.appViolentColor_6D08C3
                                            : AppColors.white,
                                      }}
                                    />
                                  )
                                )}
                              </View>
                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                }}
                              >
                                Click “Next” to start exploring the Home Page.
                              </Text>
                              <TouchableOpacity
                                onPress={() => {
                                  setSignupEventTooltipVisible(false);
                                  setTicketEventTooltipVisible(true);
                                  handleNextStep();
                                }}
                                style={{
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  width: 70,
                                  height: 20,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 10,
                                }}
                              >
                                <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                  Next
                                </Text>
                              </TouchableOpacity>
                            </View>
                          </View>
                        </View>
                      }
                      placement="top"
                    >
                      <TouchableHighlight>
                        <CommonButton
                          title="Sign-Up"
                          onTap={() => {
                            setIsSignUp(true);
                          }}
                          buttonStyle={styles.btnStyle}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                        />
                      </TouchableHighlight>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      isVisible={
                        firstSignUpIndex === index &&
                        signupEventTooltipVisible &&
                        heading === "Popular Events"
                      }
                      contentStyle={{
                        backgroundColor: AppColors.appBlueColor_3A5175,
                        width: 300,
                      }}
                      displayInsets={{ top: 0, bottom: 0, left: 10, right: 10 }}
                      arrowStyle={{
                        display: "none",
                      }}
                      content={
                        <View
                          style={{
                            backgroundColor: AppColors.appBlueColor_3A5175,
                            padding: 10,
                            flexDirection: "row",
                            gap: 10,
                          }}
                        >
                          <View style={{ flex: 1, gap: 30 }}>
                            <View style={{ gap: 10 }}>
                              <Text
                                style={[
                                  AppFontStyle.BOLD_ANYBODY_12,
                                  { color: AppColors.white }, // Set text color for better readability
                                ]}
                              >
                                Sign Up to Watch Free Events ✍️
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                Ready to join the Esquadifi community? Signing
                                up lets you access all free Kall-Out Events and
                                enjoy exciting matches live.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Join Free Events:
                                </Text>
                                Once signed up, you can register for any
                                Kall-Out Event to watch live, cheer for players,
                                and engage in chat.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Build Your Profile:
                                </Text>
                                Create your profile to track stats, interact
                                with other fans, and be part of the community.
                              </Text>
                              <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                                <Text style={{ color: AppColors.green_00FFE8 }}>
                                  Unlock Special Abilities:
                                </Text>
                                Sign up to start collecting coins, belts, and
                                real rewards as you progress in Esquadifi!
                              </Text>
                            </View>
                            <View style={{ marginTop: 10 }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Dots (Step Indicator) */}
                                <View
                                  style={{
                                    flexDirection: "row",
                                    gap: 5,
                                    alignItems: "center",
                                  }}
                                >
                                  {Array.from({ length: totalSteps }).map(
                                    (_, index) => (
                                      <View
                                        key={index}
                                        style={{
                                          height: 6,
                                          width: 6,
                                          borderRadius: 5,
                                          backgroundColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                          borderWidth: 1,
                                          borderColor:
                                            currentStep === index
                                              ? AppColors.appViolentColor_6D08C3
                                              : AppColors.white,
                                        }}
                                      />
                                    )
                                  )}
                                </View>

                                <TouchableOpacity
                                  onPress={() => {
                                    setSignupEventTooltipVisible(false);
                                    setTicketEventTooltipVisible(true);
                                    handleNextStep();
                                  }}
                                  style={{
                                    backgroundColor:
                                      AppColors.appViolentColor_6D08C3,
                                    width: 70,
                                    height: 20,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 10,
                                    cursor: "pointer",
                                  }}
                                >
                                  <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                                    Next
                                  </Text>
                                </TouchableOpacity>
                              </View>
                              <Text
                                style={{
                                  fontFamily: "Anybody_400Regular",
                                  fontSize: 12,
                                  color: AppColors.green_00FFE8,
                                  marginTop: 15,
                                }}
                              >
                                Click “Next” to start exploring the Home Page.
                              </Text>
                            </View>
                          </View>
                        </View>
                      }
                      placement="top"
                      // childContentSpacing={20}
                      // onClose={() => setToolTipVisible(false)}
                    >
                      <TouchableHighlight>
                        <CommonButton
                          title="Sign-Up"
                          onTap={() => {
                            setIsSignUp(true);
                          }}
                          buttonStyle={styles.btnStyle}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_14, {}]}
                        />
                      </TouchableHighlight>
                    </Tooltip>
                  )}
                </View>
              )
            ) : flag === 0 ? (
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  {
                    color: AppColors.white,
                    marginTop: 10,
                    width: 150,
                    textAlign: "right",
                  },
                ]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                Already Purchased
              </Text>
            ) : (
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  {
                    color: AppColors.white,
                    marginTop: 10,
                    width: 150,
                    textAlign: "right",
                  },
                ]}
                numberOfLines={1}
                ellipsizeMode="tail"
              >
                Already signedup
              </Text>
            )
          ) : null}

          {/* <View
                    style={{
                        height: 25,
                        width: 25,
                        backgroundColor: AppColors.appViolentColor_6D08C3,
                        borderRadius: 25,
                        alignSelf: "center",
                    }}
                ></View> */}
          {/* <View
                    style={{
                        flex: 1,
                        borderRadius: 10,
                        justifyContent: "center",
                        paddingHorizontal: 8,
                        gap: 3,
                    }}
                >
                    <Text
                        style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.white },
                        ]}
                    >
                        {item.title}{" "}
                    </Text>
                    <Text
                        style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { color: AppColors.white },
                        ]}
                    >
                        {item.organiserID}
                    </Text>
                </View> */}
        </View>
      )}
      {isSignUp && (
        <SignUpModal
          accessToken={accessToken}
          userId={userData.username}
          item={item}
          closeSignUp={(success) => {
            if (success) {
              setAttendeeIDs([...attendeeIDs, userData.username]); // Add the user to attendeeIDs after successful sign-up
              setIsSignUp(false); // Close the modal
            }
            setIsSignUp(false); // Close the modal
          }}
          setIsSignUp={setIsSignUp}
        />
      )}
      {isGetTicket && (
        <BuyTicketModal
          accessToken={accessToken}
          item={item}
          userData={userData}
          userProfileData={userProfileData}
          closeButTicket={(success) => {
            if (success) {
              setAttendeeIDs([...attendeeIDs, userData.username]);
              setIsGetTicket(false);
            }
            setIsGetTicket(false);
          }}
          setIsGetTicket={setIsGetTicket}
        />
      )}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    cardContainer: {
      width: 220,
    },
    detailCard: {
      height: 150,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 10,
      justifyContent: "flex-end",
      padding: 8,
      // paddingLeft: 8,
      // paddingBottom: 8,
    },
    listBgViewStyle: {
      width: 220,
      gap: 5,
    },
    attendeesBgViewStyle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 7,
      alignSelf: "flex-start",
    },

    btnStyle: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      height: 22,
      marginTop: 5,
      borderRadius: 10,
    },
    btnGetTicketStyle: {
      paddingVertical: 0,
      paddingHorizontal: 3,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      flexGrow: 1,
      height: 20,
      borderRadius: 7,
    },
    playersView: {
      flexDirection: "row",
      gap: 10,
      justifyContent: "space-evenly",
    },
    vsImage: {
      height: 59,
      width: 59,
      marginVertical: 10,
    },
    playerView: {
      borderRadius: 12,
      alignItems: "center",
    },
    playerImg: {
      height: 51,
      width: 51,
      borderWidth: 1,
      borderColor: "black",
      marginVertical: 10,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      cardContainer: {
        width: 220,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 22,
        marginTop: 5,
        borderRadius: 10,
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 3,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 20,
        borderRadius: 7,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },

      playerImg: {
        height: 51,
        width: 51,
        borderWidth: 1,
        borderColor: "black",
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      cardContainer: {
        width: 220,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 22,
        marginTop: 5,
        borderRadius: 10,
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 3,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 20,
        borderRadius: 7,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
    },
    [DEVICE_SIZES.SM]: {
      cardContainer: {
        width: 220,
      },
      detailCard: {
        height: 150,
      },
      listBgViewStyle: {
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 22,
        marginTop: 5,
        borderRadius: 10,
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 3,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 20,
        borderRadius: 7,
      },
      playersView: {
        flexDirection: "row",
        gap: 0,
      },
      vsImage: {
        width: 30,
      },
      playerImg: {
        height: 51,
        width: 51,
        borderWidth: 1,
        borderColor: "black",
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      cardContainer: {
        width: 185,
      },
      detailCard: {
        height: 150,
      },
      listBgViewStyle: {
        width: 185,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      vsImage: {
        width: 30,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 22,
        marginTop: 5,
        borderRadius: 10,
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 3,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 20,
        borderRadius: 7,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
    },
  }
);
